// extracted by mini-css-extract-plugin
export default {"stats":"Static_stats__286jE","row":"Static_row__Hep+N","stat":"Static_stat__OedOL","value":"Static_value__wyECF","label":"Static_label__l+H8s"};